export const formatter = new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
});

export const format = (number) => {
    const price = formatter.format(number).split(',')[0]
    return price.split('Rp')[1].trim()
}